import { useEffect, useState } from 'react';
import { Monster } from '../../api';
import { useMonsterTokenStyle } from '../../utils/clientSettings';
import { MonsterMarker } from '../Monsters';
import { getMonsterReworkImagePath } from '../MonsterTokenSvg';
import { GameDialog } from '../GameDialog';
import './WikiMonster.css';
import { MonsterInspectionEnabled } from '../MonsterInspector';

/** Full artwork is deliberately available only in the wiki. */
export const WikiMonster = ({ monster }: { monster: Monster }) => {
  const digital = useMonsterTokenStyle() === 'Digital';
  const [open, setOpen] = useState(false);
  const [failed, setFailed] = useState(false);
  useEffect(() => { setOpen(false); }, [digital, monster.name]);
  return <div className="wiki-monster-artwork">
    <MonsterInspectionEnabled.Provider value={false}><MonsterMarker monster={monster} monsterSize={96}
      monsterStyle={{ position: 'relative', marginLeft: 0 }} /></MonsterInspectionEnabled.Provider>
    {digital && <button type="button" className="wiki-monster-artwork-open"
      aria-label={`View full artwork for ${monster.name}`} aria-haspopup="dialog"
      onClick={() => { setFailed(false); setOpen(true); }}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth="2" aria-hidden="true" focusable="false">
        <circle cx="10" cy="10" r="6" /><path d="m14.5 14.5 6 6" />
      </svg>
    </button>}
    {digital && open && <GameDialog title={`${monster.name} artwork`} variant="artwork" onClose={() => setOpen(false)}>
      {failed ? <p role="alert">Artwork could not be loaded.</p> :
        <img className="wiki-monster-artwork-full"
          src={getMonsterReworkImagePath(monster.name).replace('/rework/', '/rework/full/')}
          alt={`${monster.name} full artwork`} width={1200} height={1200} decoding="async"
          onError={() => setFailed(true)} />}
    </GameDialog>}
  </div>;
};
